import { useEffect, useState } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { ProjectWithClientInfo } from '../../../commonTypes/acs/project.types';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { setProjects as setProjectsRedux } from '../../../store/slices/projects.slice';
import { useTranslation } from '../../useTranslation';

const useHttpGetAllProjectsOnMount = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [projects, setProjects] = useState<ProjectWithClientInfo[]>([]);

    useEffect(() => {
        const { exec, abort } = projectApi.getAllFromOrganization({
            onSuccess: res => {
                setProjects(res.body);
                dispatch(setProjectsRedux(res.body));
            },
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);

    return { isReady, projects, setProjects };
};

export default useHttpGetAllProjectsOnMount;
